export default {
  Transfer: 0, // Chuyển khoản
  CashAtKB: 1, // Tiền mặt tại KB
  CashAtNH: 2, // Tiền mặt tại NH
  None: 3, // Không chọn
};
